import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { LocalStorageService } from './local-storage.service';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  private sessionTokenKey = 'x-session-token';

  constructor(private localStorage: LocalStorageService) {}

  initializeSession(): void {
    let sessionToken = this.getSessionToken();

    if (!sessionToken) {
      console.log('No session token found. Creating a new session token.');
      sessionToken = uuidv4(); // Generate a new UUID for the session token
      this.localStorage.setItem(this.sessionTokenKey, sessionToken);
      console.log(`Session Token created :: ${sessionToken}`);
    } else {
      console.log('Session token found:', sessionToken);
    }
  }

  getSessionToken(): string | null {
    return this.localStorage.getItem(this.sessionTokenKey);
  }
}
